module.exports = __webpack_public_path__ + "img/real-madrid-logo-icon.992203b3.png";